import { Check, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink } from "@/lib/contact";
import { trackCta } from "@/lib/track";

export function ExtraSections({ sections, waMessage }) {
  const settings = useSettings();
  if (!sections?.length) return null;
  return (
    <>
      {sections.map((sec, i) => (
        <Reveal key={i}>
          <div className="border-l-2 border-gold/60 pl-5 sm:pl-7" data-testid={`extra-section-${i}`}>
            <h2 className="font-display text-2xl font-medium text-white sm:text-[1.7rem]">{sec.title}</h2>
            {sec.body && <p className="mt-4 text-base leading-relaxed text-neutral-300">{sec.body}</p>}
            {sec.bullets?.length > 0 && (
              <ul className="mt-4 space-y-2.5">
                {sec.bullets.map((b, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm leading-relaxed text-neutral-200">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> <span>{b}</span>
                  </li>
                ))}
              </ul>
            )}
            {sec.cta && (
              <a
                href={whatsappLink(settings, sec.cta_message || waMessage)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCta(`whatsapp-section-${i}`)}
                data-testid={`extra-section-cta-${i}`}
                className="mt-5 inline-flex items-center gap-2 border border-gold/40 bg-gold/[0.06] px-5 py-3 font-oswald text-xs font-bold uppercase tracking-[0.15em] text-gold transition-colors hover:bg-gold hover:text-black"
              >
                <MessageCircle className="h-4 w-4" /> {sec.cta}
              </a>
            )}
          </div>
        </Reveal>
      ))}
    </>
  );
}
